exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rangeControl__inputs___2RGkg {\n  top: 5px; }\n\n.rangeControl__inputsWithTitle___2UzjS {\n  margin-top: 22px; }\n", ""]);

// exports
exports.locals = {
	"inputs": "rangeControl__inputs___2RGkg",
	"inputsWithTitle": "rangeControl__inputsWithTitle___2UzjS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/RangeControl/rangeControl.scss
// module id = 2170
// module chunks = 6